import React, {Component} from 'react'
import {Field, FieldsManager} from "../../../../data/services/fields";
import {createResource, deleteResource, getResource, updateResource} from "../../../../data/actions/resource";
import LocalStorage from "../../../util/localStorage";
import {fieldsToHtml, fillFieldsFromData} from '../../../util/util-fields'
import {download, uploadDocument} from "../../../../data/actions/download";
import Env from "../../../../util/env";
import icons, {HourglassIcon} from "../../../../data/themes/icons";
import moment from "moment-timezone";
import Resources from "../../../../data/services/resources";
import {ArrowDownTrayIcon, Bars4Icon, EnvelopeIcon, EyeIcon, TrashIcon} from '@heroicons/react/24/outline'
import NoRecords from "../../no-records-found/no-records";
import TableFilters from "../../resource-table/table-components/table-filters";
import Card from "../../card";
import Tippy from "@tippyjs/react";
import DocumentsBoardView from "./documents-board-view";
import {CheckCircleIcon, Squares2X2Icon} from "@heroicons/react/20/solid";
import DocumentPreviewModal from "./document-preview-modal";
import FieldCheckbox from "../../fields/field-checkbox";
import {
    DEFAULT_CRUD_STATE,
    DEFAULT_DOCUMENTS_ACCEPTABLE_EXTENSIONS,
    DEFAULT_METADATA_SELECT_SEARCH_QUERY,
} from '../../../../util/util-constants'
import {
    checkPerm,
    classNames,
    getDefaultTableOptions,
    getLookup,
    getProp,
    mergeDeep,
    saveTableColumns
} from "../../../util/util-helpers";
import {currentDate, toFrontDateNoTime} from "../../../util/util-dates";
import ModalConfirm from "../../modal/modal-confirm";
import TableCard from "../../resource-table/table-components/table-card";
import ModalDefault from "../../modal/modal-default";
import ModalSaveResource from '../../modal/modal-save-resource'
import FileViewer from "../../file-viewer/components";
import DocumentVersionsModal from "./document-versions-modal";
import InfoBar from "../../info-paragraph/info-bar";
import FieldSwitch from "../../fields/field-switch";
import ActiveFilters from "../../resource-table/table-components/active-filters";
import ResourceTable from "../../resource-table";
import EmailDocumentDialog from "../../modal/modal-email-documents/modal-email-document";
import DropZone from "../../../../common/components/dropzone/drop-zone-alt";
import CardSubTitle from "../../card/card-sub-title";
import {getJWT} from "../../../util/util-auth";
import CompanyExceptions from "../../../util/util-exceptions";
import {UPDATE_PERM} from "../../../util/util-consts";
import {pushNotification} from "../../../../data/actions/ui";

export default class DocumentsUpdateTab extends Component {

    constructor(props) {
        super(props);
        this.pagePath = this.props?.pagePath

        const storage = LocalStorage.get(this.pagePath + "_state")

        const dataView = storage?.dataView ?? 'table'

        this.state = {
            ...DEFAULT_CRUD_STATE,
            sortBy: this.props.sortBy ?? "",

            searchFields: this.props.searchFields ?? {},

            fields: this.getFields(),
            tableFields: this.getTableFields(),
            tableOptions: getDefaultTableOptions(this.getTableFields(), {
                behaviour: {
                    rowSelect: false,
                    canAdjustWidth: true,
                    hasMenu: false
                }
            }, this.pagePath, this.props.translate),

            files: [],
            file: null,

            selectedItem: null,
            uploadFilesModalOpen: false,
            confirmModalOpen: false,
            isUpdateModalOpen: false,
            emailModalOpen: false,

            canSubmit: this.props.canSubmit ?? false,

            dataView: dataView,
            isDocumentDragged: false,
            fileTypeUploading: '',
            willCopyValues: true,
            queryToggleValue: this.props.queryToggleFilter?.defaultValue ?? false,
        };

        this.DropZoneClickRef = React.createRef();

        this.areCheckboxesTouched = false;

        this.tableActions = [
            {
                action: this.toggleSendEmailDialog,
                icon: EnvelopeIcon, // make this a function
                visible: (it) => {
                    if (this.props.disableSendViaEmail) {
                        return !this.props.disableSendViaEmail
                    } else if (this.props.RCdisableEmail) {
                        return !it?.DocumentType?.toLowerCase()?.includes("rate confirmation");
                    } else return true
                },
                label: false, // make this a function
                title: this.props.translate('btn.send_document_via_email'),
                disabled: false,
                class: false,
                iconClass: false
            },
            {
                action: this.handleToggleVersionsModal,
                customContent: () => <HourglassIcon className="w-5 h-5"/>, // make this a function
                visible: () => (this.props.hasEditPerm ?? !this.props.readOnly) && this.props.hasVersioning !== false,
                label: false, // make this a function
                title: this.props.translate('text.version_manager'),
                disabled: false,
                class: false,
                iconClass: false
            },
            {
                action: this.downloadDocument,
                icon: ArrowDownTrayIcon, // make this a function
                visible: () => true,
                label: false, // make this a function
                title: this.props.translate('btn.Download'),
                disabled: false,
                class: false,
                iconClass: false
            },
        ];

        if (this.props.additionalTableActions) {
            this.tableActions = this.tableActions.concat(this.props.additionalTableActions)
        }

        this.state = mergeDeep(this.state, LocalStorage.rehydrateState(this.pagePath));

        this.docsTypes = getLookup('DocumentType', 'DocumentTypeID', 'DocumentType');
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        this.fetchData();
        this.applyToggleColumnWidths(this.state.queryToggleValue);

        if (!!this.props?.fetchInfoData && !this.props?.info?.isLoading && this.props?.info?.data?.LoadID !== Number(this.props?.id)) {
            this.props.fetchInfoData();
        }

        document.addEventListener("mouseup", this.handleMouseUp);
        document.addEventListener("dragend", this.handleMouseUp);
        document.addEventListener("drop", this.handleMouseUp);
        document.addEventListener("mouseleave", this.handleMouseUp);
    }

    componentWillUnmount() {
        document.removeEventListener("mouseup", this.handleMouseUp);
        document.removeEventListener("dragend", this.handleMouseUp);
        document.removeEventListener("drop", this.handleMouseUp);
        document.removeEventListener("mouseleave", this.handleMouseUp);
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.resource !== this.props.resource && !!this.state.versionsModalOpen) {
            const item = this.getData().find(it => it.uuid === this.state.selectedItem.uuid);
            if (item) {
                this.setState({
                    selectedItem: item
                })
            } else {
                this.handleToggleVersionsModal()
            }
        }

        if (prevState.uploadFilesModalOpen !== this.state.uploadFilesModalOpen) {
            this.areCheckboxesTouched = false;
        }
    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        if (this.props.onFetchData) {
            this.props.onFetchData({query: this.getQuery(), resource: this.getResourceName()})
        } else {
            this.props.dispatch(getResource({
                user: LocalStorage.get("user"),
                query: this.getQuery(),
                resource: this.getResourceName()
            }))
        }
    };

    downloadDocument = (document) => {
        const fileExt = (document?.DocumentName ?? "").split('.').pop();

        if (!fileExt) {
            console.log("Error in document name:", document?.DocumentName);
        }

        this.props.dispatch(download({
            user: LocalStorage.get("user"),
            resource: this.getResourceName(),
            query: Object.assign({
                [this.getPrimaryKey()]: document[this.getPrimaryKey()],
                id: this.getId(),
                format: fileExt,
                name: document?.OriginalFilename ?? "document_" + currentDate() + "." + fileExt
            })
        }))
    }

    onUploadVersion = (document, params = {}) => {
        const files = [Object.assign(document, {
            params: Object.assign({}, {
                uuid: this.state.selectedItem.uuid,
                name: document.name
            }, params)
        })]

        this.props.dispatch(uploadDocument({
            user: LocalStorage.get("user"),
            files: files,
            id: this.getId(),
            query: Object.assign({}, {
                id: this.props.id,
            }, this.getQuery()),
            resource: this.getResourceName(),
            errorMessage: true,
            successMessage: `New Version has been uploaded successfully.`,
            piggyResource: this.getPiggyResourceName()
        }))
    }

    /** UI Events
     ================================================================= */
    handleUpdateSort = (sortBy) => {
        this.setState({
            sortBy: sortBy,
            sort: (this.state.sortBy === sortBy) ? (this.state.sort === "ASC" ? "DESC" : "ASC") : "ASC"
        }, () => this.fetchData());
    };

    handleUpdateOffset = (offset, page) => {
        this.setState({
            offset: offset,
            paginationPage: page
        }, () => this.fetchData());
    }

    handleToggleViewDocument = (item = null) => {
        let documentIndex = null
        if (item) {
            documentIndex = this.getData().findIndex(elem => elem.DocumentID === item.DocumentID)
        }

        this.setState({
            previewDocumentDialog: !this.state.previewDocumentDialog,
            documentIndex: documentIndex,
            selectedItem: item
        });
    }

    handleOnPreviousDocumentPreviewClick = () => {
        this.state.documentIndex > 0 && this.setState({documentIndex: this.state.documentIndex - 1})
    }

    handleOnNextDocumentPreviewClick = () => {
        this.state.documentIndex < (this.getData().length - 1) && this.setState({documentIndex: this.state.documentIndex + 1})
    }

    handleDownloadDocument = () => {
        this.downloadDocument(this.getData()[this.state.documentIndex])
        this.handleToggleViewDocument()
    }

    handleToggleConfirmModal = (item = null) => {
        this.setState({
            selectedItem: item,
            confirmModalOpen: !this.state.confirmModalOpen
        })
    }

    handleToggleVersionsModal = (item = null) => {
        this.setState({
            selectedItem: item,
            versionsModalOpen: !this.state.versionsModalOpen
        })
    }

    handleFilterInputChange = (name, value) => {
        this.setState({searchFields: FieldsManager.updateField(this.state.searchFields, name, value)}, () => this.saveFilters());

    }

    handleFilterClear = () => {
        this.setState({
            searchFields: this.props.searchFields ?? {},
        }, () => {
            this.fetchData();
            this.saveFilters();
        })
    }

    handleCancelUpload = () => {
        this.setState({
            uploadFilesModalOpen: false,
            files: [],
            fields: this.getFields()
        });
    }

    showPreviewModal = (item) => {
        this.setState({showPreviewModal: true, previewFile: item})
    }

    handleUploadDocumentType = (DocumentTypeID) => {
        this.setState({
            fileTypeUploading: DocumentTypeID,
        }, () => {
            this.DropZoneClickRef?.current?.click();
        });
    }

    downloadPreview = (uri, name) => {
        const link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    handleRemoveDocumentFromUpload = (index) => {
        let files = this.state.files
        files.splice(index, 1)
        if (files.length === 0) {
            this.handleCancelUpload()
        } else {
            this.setState({files})
        }
    }

    handleInputChange = (name, value, i) => {
        let files = [...this.state.files];
        files[i].fields = FieldsManager.updateField(files[i].fields, name, value);

        // Auto-check IsSendWithInvoice and IsVisibleForCustomer for document types
        // commonly shared with customers (Rate Confirmation, POD).
        if (name === "DocumentTypeID") {

            const label = this.docsTypes[value] || '';
            if (this.documentLabelTest(label) && CompanyExceptions('AutoCheckPODDocumentCheckboxes', true)) {
                files[i].fields.IsSendWithInvoice.value = 1;
                files[i].fields.IsVisibleForCustomer.value = 1;
            }
        }

        let updateIsVisibleForCustomer = false;

        if (!i && name === "IsSendWithInvoice") {
            // In value is initialy false, checking IsSendWithInvoice will also check IsVisibleForCustomer
            if (!this.areCheckboxesTouched && value) {
                files[i].fields.IsVisibleForCustomer.value = value;
                updateIsVisibleForCustomer = true;
            }

            this.areCheckboxesTouched = true;
        }

        if (!i && this.state.willCopyValues) {
            files = files.map((file, fileIndex) => {
                if (fileIndex) {
                    file.fields[name].value = value;

                    if (updateIsVisibleForCustomer) {
                        file.fields.IsVisibleForCustomer.value = value;
                    }
                }

                return file
            });
        }

        this.setState({
            files,
            canSubmit: true
        })
    };

    handleUploadDocument = () => {
        const LoadInfo = getProp(this.props.resource, "data.info", false)

        if (this.state.files.length === 0) {
            this.handleCancelUpload();
            this.props.dispatch(pushNotification({
                    title: `Error uploading document`,
                    content: "Please try again",
                    messageType: "error"
                }
            ));
            throw new Error('Error uploading document. Files are missing from the state.');
        }

        this.setState({
            files: this.state.files.map((file) => Object.assign(file, {
                fields: FieldsManager.validateFields(file.fields)
            }))
        }, () => {
            if (this.state.files.reduce((memo, file) => (memo && FieldsManager.checkFieldsForErrors(file.fields)), true)) {
                const files = this.state.files.map(file => {
                    const { path, preview, errorMessage, fields } = file;
                    if (this.props?.info?.data?.LoadID && CompanyExceptions('LoadDocumentsLoadNumbersInName', false)) {

                        const renamedFile = new File([file], LoadInfo.LoadNumber + "_" + LoadInfo.CustomerReferenceNumber + "_" + file.name, {type: file.type});

                        return Object.assign(renamedFile, {
                            path,
                            preview,
                            errorMessage,
                            fields,
                            params: Object.assign({}, FieldsManager.getFieldKeyValues(fields), {
                                Version: 0
                            })
                        });
                    }


                    return Object.assign(file, {
                        params: Object.assign({}, FieldsManager.getFieldKeyValues(file.fields), {
                            Version: 0
                        })
                    });
                })

                this.props.dispatch(uploadDocument({
                    user: LocalStorage.get("user"),
                    files: files,
                    id: this.getId(),
                    query: Object.assign({}, this.getQuery()),
                    resource: this.getResourceName(),
                    errorMessage: true,
                    successMessage: `Attachment${this.state.files.length > 1 ? "s" : ""} ${this.state.files.length > 1 ? "have" : "has"} been uploaded successfully.`,
                    piggyResource: this.getPiggyResourceName()
                }))
                this.handleCancelUpload()
            }
        })
    }

    handleReturnExpiryDate = (item) => {
        let ExpiryDate = item.ExpiryDate
        let today = moment().format("YYYY-MM-DD HH:mm:ss")
        let x = 7
        let xDaysBefore = moment(ExpiryDate).add(-x, 'days').format("YYYY-MM-DD HH:mm:ss")
        let styles = 'text-tm-gray-700 py-0.5 h-6'
        if (ExpiryDate) {
            if (xDaysBefore < today && today < ExpiryDate) {
                styles = 'btn-warning text-inverse'
            }
            if (today > ExpiryDate) {
                styles = 'btn-danger'
            }
        }
        return (
            <>
                <button className={`btn btn-xs active ${styles}`}>
                    {toFrontDateNoTime(ExpiryDate)}
                </button>
            </>
        )
    }

    toggleSendEmailDialog = (item = null) => {
        // ignore event
        item = item?.current ? null : item;

        this.setState({
            emailModalOpen: !this.state.emailModalOpen,
            selectedItem: item
        })
    }

    handleSetDataView = (view) => {
        this.setState({dataView: view}, () => {
            LocalStorage.persistState(this.pagePath, this.state, ['searchFields', 'dataView']);
            this.fetchData()
        })
    }

    handleToggleUpdateModal = (item = null) => {
        this.setState({
            isUpdateModalOpen: !this.state.isUpdateModalOpen,
            selectedItem: item,
        })
    }

    setOptions = (options) => {
        this.setState({
            tableOptions: options
        }, () => saveTableColumns(this.pagePath, options))
    }

    applyToggleColumnWidths = (isToggleOn) => {
        if (!this.props.hideFieldsWhenToggleOff?.length) {
            return;
        }

        const columns = Object.assign({}, this.state.tableOptions.columns);

        this.props.hideFieldsWhenToggleOff.forEach((key) => {
            if (columns[key]) {
                columns[key] = Object.assign({}, columns[key], {show: isToggleOn});
            }
        });

        const visibleKeys = Object.keys(this.state.tableFields).filter(key => columns[key]?.show !== false);
        const lastVisibleKey = visibleKeys[visibleKeys.length - 1];

        // Last visible column always stays flexible so it fills any leftover table width
        // (it naturally falls back to the normal column width once that would cause a horizontal scrollbar).
        if (columns[lastVisibleKey]) {
            columns[lastVisibleKey] = Object.assign({}, columns[lastVisibleKey], {minWidth: undefined});
        }

        const widthMap = this.props.columnMinWidthWhenToggleOn ?? {};
        Object.keys(widthMap).forEach((key) => {
            if (columns[key] && key !== lastVisibleKey) {
                columns[key] = Object.assign({}, columns[key], {
                    minWidth: isToggleOn ? widthMap[key] : undefined
                });
            }
        });

        this.setOptions(Object.assign({}, this.state.tableOptions, {columns}));
    }
    /** Helpers
     ================================================================= */
    getDocumentUploadFields = (index = 0) => {
        let fields;
        const DocumentTypeID = this.state.fileTypeUploading ?? '';

        if (this.props.documentUploadFields) {
            fields = Object.assign({}, this.props.documentUploadFields(index))
        } else {

            fields = {
                DocumentTypeID: new Field("DocumentTypeID", '', ['empty'], false, 'select'),
                ExpiryDate: new Field("ExpiryDate", '', [], false, 'date'),
                Description: new Field("Description", '', [], false, 'textarea'),
            }
        }

        if (!!DocumentTypeID && !!fields.DocumentTypeID) {
            fields.DocumentTypeID.value = DocumentTypeID;
        }

        return fields;
    }

    getId = () => {
        return this.props.id;
    }

    getPrimaryKey = () => {
        return this.props.documentID ?? "DocumentID";
    }

    getResourceName = () => {
        return this.props.createOnly ? Resources.LoadDocumentsCreate : this.props.resourceName ?? "";
    }

    getPiggyResourceName = () => {
        return this.props.piggyResourceName ?? this.getResourceName()
    }

    getQuery = () => {
        return {
            id: this.getId(),
            limit: 200,
            offset: 0,
            sort: this.state.sort,
            sortBy: this.state.sortBy,
            ...(this.props.queryToggleFilter && this.state.queryToggleValue
                ? {[this.props.queryToggleFilter.key]: 1}
                : {}),

            // ...FieldsManager.getFieldKeyValues(this.state.searchFields),
            // searchFields: JSON.stringify({DocumentTypeID: this.state.searchFields.DocumentTypeID?.value})
        }
    }

    getFields = () => {
        return {
            DocumentTypeID: new Field("DocumentTypeID", '', ['empty'], false, 'select'),
        }
    };

    getUpdateFields = (item = null) => {
        let fieldTemplates = Object.assign({}, this.props.documentUpdateFields);

        if (fieldTemplates.DocumentReviewStatusID) {
            if (item?.IsUploadedByDriver && checkPerm(Resources.LoadDocumentsReview, UPDATE_PERM)) {
                fieldTemplates.DocumentReviewStatusID.type = 'select'
                if (item.DocumentReviewStatusID === 0) {
                    item.DocumentReviewStatusID = '0'
                }
            } else {
                delete fieldTemplates.DocumentReviewStatusID
            }
        }

        return fillFieldsFromData(fieldTemplates, item);
    }

    getEmailFields = () => {
        return {
            EmailTemplateID: new Field("EmailTemplateID", '', [''], false, 'select-search', {addContainerClass: "relative col-span-3 md:col-span-6"}),
            emails: new Field("emails", '', ['empty'], false, 'creatable', {
                addContainerClass: "col-span-8",
                onEnterDown: true
            }, {isMulti: true, components: {DropdownIndicator: null}, menuIsOpen: false, placeholder: "Type email..."}),
            AddContactID: new Field("AddContactID", '', [''], false, 'select-search', {addContainerClass: "col-span-4 -ml-px"}, {placeholder: "Filter contacts..."}),
            subject: new Field("subject", '', ['empty'], false, 'text', {addContainerClass: "col-span-full"}),
            emailMessage: new Field("emailMessage", '', [], false, 'rich-text', {addContainerClass: "col-span-full"}),
        }
    }
    getTableFields = () => {
        const baseFields = {
            Description: new Field("Description", '', [], false, 'textarea'),
            DocumentTypeID: new Field("DocumentTypeID", '', ['empty'], false, 'select'),
            UpdatedByContact: new Field("UpdatedByContact", '', [''], false, 'custom', {
                render: (item) => <>{item.UpdatedByContact ?? this.props.translate("text.system")}</>,
                omitSort: true
            }),
            CreateUpdateDate: new Field("CreateUpdateDate", '', ['empty'], false, 'date'),
            ExpiryDate: new Field("ExpiryDate", '', [], false, 'custom', {
                render: (item) => this.handleReturnExpiryDate(item)
            })
        };
        const additionalFields = this.props.additionalTableFields ?? {};
        const insertAfterKey = this.props.additionalTableFieldsInsertAfter;

        if (!insertAfterKey || !(insertAfterKey in baseFields)) {
            return Object.assign({}, baseFields, additionalFields);
        }

        const orderedFields = {};
        Object.entries(baseFields).forEach(([key, field]) => {
            orderedFields[key] = field;
            if (key === insertAfterKey) {
                Object.assign(orderedFields, additionalFields);
            }
        });
        return orderedFields;
    };

    getFileExtension = (fileName = '') => {
        const ext = fileName.split('.').pop();
        const documentExt = ['doc', 'docx', 'xlsx', 'txt', 'pdf', 'png', 'jpg'];
        if (documentExt.includes(ext)) {
            return icons[ext];
        }

        return icons.DefaultDocumentIcon
    }

    onDragEnter = () => {
        this.setState({
            dropzoneActive: true
        });
    }

    onDragLeave = () => {
        this.setState({
            dropzoneActive: false
        });
    }

    onDrop = () => {
        this.setState({
            dropzoneActive: false,
            uploadFilesModalOpen: true
        });
    }

    onlyUnique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    getData = () => {
        return getProp(this.props, "resource.data.list", [])
            .filter(it => {
                let extention = it?.OriginalFilename ? it.OriginalFilename.split('.').pop() : '';
                const {
                    DocumentTypeID,
                    DocumentExtension,
                    IsSendWithInvoice,
                    IsVisibleForCustomer,
                    query
                } = FieldsManager.getFieldKeyValues(this.state.searchFields)

                if (it.ArchivedDate) {
                    it.ArchivedDate = null;
                }

                if (!!DocumentTypeID && (DocumentTypeID != it.DocumentTypeID)) {
                    return false;
                }

                if (!!DocumentExtension && (DocumentExtension != extention)) {
                    return false;
                }

                if (!!query && (!it.Description?.toLowerCase()?.includes(query.toLowerCase()) && !it.DocumentName?.toLowerCase()?.includes(query.toLowerCase()))) {
                    return false;
                }

                if (!!IsVisibleForCustomer && !it.IsVisibleForCustomer) {
                    return false
                }

                if (!!IsSendWithInvoice && !it.IsSendWithInvoice) {
                    return false
                }

                return true;
            })
    }

    handleDocumentDragEnter = () => {
        if (!this.state.uploadFilesModalOpen) {
            this.setState({
                isDocumentDragged: true
            });
        }
    }

    handleDocumentDragStop = () => {
        this.setState({
            isDocumentDragged: false
        })
    }

    saveFilters = () => {
        LocalStorage.persistState(this.pagePath, this.state, ['searchFields', 'dataView', 'queryToggleValue'])
    }

    handleMouseUp = () => {
        if (this.state.isDocumentDragged) {
            this.setState({
                isDocumentDragged: false
            })
        }
    }

    documentLabelTest = (label) => {
        return /rate confirmation|pod|lumper/i.test(label);
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, resource, createOnly, disableDelete, disableSendViaEmail, readOnly, download} = this.props;

        const data = this.getData()

        const LoadInfo = getProp(resource, "data.info", false)

        const documentIDs = getProp(this.props, "resource.data.list", []).map(it => it.DocumentTypeID)
        const requiredDocumentIDs = getProp(this.props, "resource.data.requiredDocuments", []).map(it => it.DocumentTypeID)
        let intersectionArray = documentIDs
            .filter(x => requiredDocumentIDs.indexOf(x) !== -1)
            .filter(this.onlyUnique);

        const requiredDocuments = getProp(this.props, "resource.data.requiredDocuments", []).map((item, i) => {
            const hasType = documentIDs.includes(item.DocumentTypeID);

            const label = this.docsTypes[item.DocumentTypeID];

            return (
                <div
                    key={item?.CustomerRequiredDocumentsID ?? i}
                    className={
                        classNames(
                            "cursor-pointer flex gap-x-2 items-center text-sm font-medium px-2.5 py-0.5 rounded-sm",
                            hasType ? "bg-green-600/10 text-tm-gray-900" : "bg-red-600/10 text-tm-gray-900"
                        )
                    }
                    onClick={() => {
                        return hasType
                            ? this.handleFilterInputChange("DocumentTypeID", item.DocumentTypeID)
                            : this.handleUploadDocumentType(item.DocumentTypeID)
                    }}
                >
                    {hasType && (
                        <CheckCircleIcon className="text-green-600 w-5 h-5"/>
                    )}
                    {item.DocumentType}
                </div>
            )
        })

        const isLoading = resource.isLoading || download.isLoading

        return <>
            <div>
                {!readOnly && LoadInfo && (
                    <>
                        <InfoBar addClass="mb-6">
                            {translate("text.LoadDocumentsInfoParagraph")}
                        </InfoBar>

                        <div className="mb-4 mt-4">
                            <ActiveFilters
                                filterFields={this.state.searchFields}
                                onLabelClick={this.handleFilterInputChange}
                                onClearFiltersClick={this.handleFilterClear}
                                translate={translate}
                            />
                        </div>
                    </>
                )}

                <Card
                    addClass="relative pb-10"
                    onDragEnter={this.handleDocumentDragEnter}
                >
                    {(!readOnly || createOnly) && (
                        <DropZone
                            className={
                                classNames(
                                    "absolute mb-0",
                                    this.state.isDocumentDragged ? "inset-0 z-50" : "left-0 right-0 bottom-0"
                                )
                            }
                            maxFilesAccepted={10}
                            accept={DEFAULT_DOCUMENTS_ACCEPTABLE_EXTENSIONS}
                            translate={translate}
                            onAcceptFiles={(acceptedFiles) => {
                                this.setState({
                                    files: acceptedFiles.map((file, index) => Object.assign(file, {
                                        preview: URL.createObjectURL(file),
                                        errorMessage: '',
                                        fields: Object.assign({}, this.getDocumentUploadFields(index))
                                    })),
                                    uploadFilesModalOpen: true,
                                    isDocumentDragged: false,
                                    canSubmit: !!this.state.fileTypeUploading
                                }, () => {
                                    this.setState({
                                        fileTypeUploading: ''
                                    })
                                });
                            }}
                            content={(isDragAccept, isDragReject) => {
                                return (
                                    <React.Fragment>
                                        <div
                                            className={classNames(
                                                (this.state.isDocumentDragged && isDragAccept) ? "border-2 border-dashed border-green-600 bg-green-600/10" : undefined,
                                                (this.state.isDocumentDragged && isDragReject) ? " border-2 border-dashed border-red-600 bg-red-600/10" : undefined,
                                                !isDragAccept && !isDragReject ? "border-transparent hidden" : undefined,
                                                "pb-4 absolute inset-0 rounded-card"
                                            )}
                                            onDragLeave={this.handleDocumentDragStop}
                                        >

                                        </div>

                                        <div
                                            className={"absolute bottom-0 left-0 right-0 px-6 cursor-pointer py-2.5 border-t border-primary border-dotted bg-primary-transparent text-lg flex justify-center"}>
                                            Attach files by dragging and dropping them or
                                            <span className="text-primary-tint font-semibold mx-2"
                                                  ref={this.DropZoneClickRef}>{" "} click here</span> to
                                            select them.
                                        </div>
                                    </React.Fragment>
                                )
                            }}
                        />
                    )}

                    {!createOnly && (
                        <div className="grid gap-4 xl:grid-cols-12">
                            <div className="col-span-full">
                                <TableFilters
                                    className="flex"
                                    hideLimit
                                    filterFields={this.state.searchFields}
                                    handleInputChange={this.handleFilterInputChange}
                                    translate={translate}
                                    onRefreshTable={this.fetchData}
                                    isLoading={isLoading}
                                >
                                    {this.props.queryToggleFilter && (
                                        <div className="flex items-center gap-2 mr-4">
                                            <FieldSwitch
                                                id="queryToggleFilter"
                                                name="queryToggleFilter"
                                                value={this.state.queryToggleValue}
                                                onChange={(_, value) => this.setState({queryToggleValue: value}, () => {
                                                    this.fetchData();
                                                    this.saveFilters();
                                                    this.applyToggleColumnWidths(value);
                                                })}
                                            />
                                            <label className="" htmlFor="queryToggleFilter">{this.props.queryToggleFilter.label}</label>
                                        </div>
                                    )}
                                    {data.length > 0 && (
                                        <div className="flex justify-end items-start">
                                            <Tippy content={translate("text.table_view")}>
                                                <button
                                                    onClick={() => this.handleSetDataView("table")}
                                                    className={classNames(this.state.dataView === "table" ? "text-primary bg-inverse" : "bg-disabled text-tm-gray-400", "-mr-px relative inline-flex items-center px-4 py-2 rounded-l-btn border border-tm-gray-300 text-sm font-medium focus:z-10 focus:outline-hidden focus:ring-1")}
                                                >
                                                    <Bars4Icon className="h-5 w-5" aria-hidden="true"/>
                                                </button>
                                            </Tippy>
                                            <Tippy content={translate("text.grid_view")}>
                                                <button
                                                    onClick={() => this.handleSetDataView("grid")}
                                                    className={classNames(this.state.dataView === "grid" ? "text-primary bg-inverse" : "bg-disabled text-tm-gray-400", "-ml-px relative inline-flex items-center px-4 py-2 rounded-r-btn border border-tm-gray-300 text-sm font-medium focus:z-10 focus:outline-hidden focus:ring-1")}
                                                >
                                                    <Squares2X2Icon className="h-5 w-5" aria-hidden="true"/>
                                                </button>
                                            </Tippy>
                                        </div>
                                    )}
                                </TableFilters>
                            </div>
                        </div>
                    )}

                    {!createOnly && (
                        <>
                            <div className="flex justify-between items-center">
                                <div className="flex flex-wrap gap-4">
                                    {!!requiredDocuments.length && (
                                        <InfoBar className="flex gap-2 px-2 h-6 rounded-md items-center">
                                            {translate("text.RequiredDocumentsUploaded", [intersectionArray.length, requiredDocuments.length])}
                                        </InfoBar>
                                    )}

                                    {requiredDocuments.length > 0 && requiredDocuments}

                                    {(!readOnly && LoadInfo?.IsPODReady) ? (
                                        <div
                                            className="gap-2 h-6 flex items-center">
                                            <FieldSwitch
                                                id="IsPODReviewed"
                                                onChange={(_, value) => {
                                                    this.props.dispatch(updateResource({
                                                        user: LocalStorage.get("user"),
                                                        params: {
                                                            LoadID: this.getId(),
                                                            IsPODReviewed: value ? 1 : 0
                                                        },
                                                        resource: Resources.LoadPODReviewed,
                                                        piggyResource: this.getPiggyResourceName(),
                                                        piggyQuery: this.getQuery()
                                                    }))
                                                }}
                                                value={!!LoadInfo?.IsPODReviewed}
                                                name={"IsPODReviewed"}
                                            />
                                            <label className={""}
                                                   htmlFor="IsPODReviewed">{translate("field.IsPODReviewed")}</label>
                                        </div>
                                    ) : ""}
                                </div>
                            </div>
                        </>
                    )}

                    {createOnly && (
                        <>
                            <InfoBar addClass="mb-6">
                                {translate("text.LoadDocumentsDropOffOnly")}
                            </InfoBar>
                        </>
                    )}

                    {createOnly && (
                        <>
                            <TableCard addClass={'relative z-0'}>
                                <ResourceTable
                                    data={data}
                                    fields={this.state.tableFields}

                                    limit={this.getQuery()?.limit}

                                    translate={translate}
                                    isLoading={isLoading}
                                    sort={this.state.sort}
                                    sortBy={this.state.sortBy}
                                    onSortChange={this.handleUpdateSort}
                                    maxHeightClass="max-h-[calc(100vh-29rem)]"

                                    options={this.state.tableOptions}

                                    saveTableOptions={this.setOptions}
                                    hasEditPerm={false}
                                    actions={[
                                        {
                                            action: this.handleToggleVersionsModal,
                                            customContent: () => <HourglassIcon className="w-5 h-5"/>, // make this a function
                                            visible: () => this.props.hasVersioning !== false,
                                            label: false, // make this a function
                                            title: this.props.translate('text.version_manager'),
                                            disabled: false,
                                            class: false,
                                            iconClass: false
                                        }
                                    ]}
                                />
                            </TableCard>
                        </>
                    )}

                    {!createOnly &&
                        (<>
                                {this.state.dataView === "table" && (
                                    <TableCard addClass={'relative z-0'}>
                                        <ResourceTable
                                            data={data}
                                            fields={this.state.tableFields}

                                            limit={this.getQuery()?.limit}

                                            translate={translate}
                                            isLoading={isLoading}
                                            sort={this.state.sort}
                                            sortBy={this.state.sortBy}
                                            onSortChange={this.handleUpdateSort}
                                            maxHeightClass="max-h-[calc(100vh-29rem)]"

                                            options={this.state.tableOptions}

                                            saveTableOptions={this.setOptions}
                                            onRowClick={this.handleToggleViewDocument}
                                            onView={this.handleToggleViewDocument}
                                            onDelete={!disableDelete && this.handleToggleConfirmModal}
                                            onEdit={this.props.documentUpdateFields ? this.handleToggleUpdateModal : null}
                                            hasEditPerm={this.props.hasEditPerm}
                                            actions={this.tableActions}
                                            isRowActionable={this.props.isRowActionable}
                                        />
                                    </TableCard>
                                )}

                                {this.state.dataView === "grid" && (
                                    <div className="max-h-[calc(100vh-500px)] overflow-y-auto">
                                        <DocumentsBoardView
                                            disableDelete={disableDelete}
                                            disableSendViaEmail={disableSendViaEmail}
                                            data={data}
                                            isLoading={isLoading}
                                            RCdisableEmail={this.props.RCdisableEmail}
                                            translate={this.props.translate}
                                            onGetFileExtension={this.getFileExtension}
                                            onGetReturnExpiryDate={this.handleReturnExpiryDate}
                                            onToggleViewDocument={this.handleToggleViewDocument}
                                            onToggleSendEmailDialog={this.toggleSendEmailDialog}
                                            onToggleConfirmModal={this.handleToggleConfirmModal}
                                            onDownloadDocument={this.downloadDocument}
                                            isRowActionable={this.props.isRowActionable}
                                        />
                                    </div>
                                )}

                                <NoRecords
                                    show={(data.length === 0) && !isLoading}
                                    title={translate("text.no_records")}
                                    addClass={'pt-10 pb-10'}
                                />
                            </>
                        )}

                    <ModalConfirm
                        title={"Confirm"}
                        show={!!this.state.confirmModalOpen}
                        text={translate("text.confirm_delete_document")}
                        onClose={() => this.setState({confirmModalOpen: false})}
                        buttonLabel={translate("btn.confirm")}
                        closeButtonLabel={translate('btn.cancel')}
                        translate={translate}
                        onConfirm={() => {
                            let id = this.state.selectedItem[this.getPrimaryKey()]
                            this.props.dispatch(deleteResource({
                                user: LocalStorage.get("user"),
                                query: {
                                    [this.getPrimaryKey()]: id
                                },
                                piggyQuery: this.getQuery(),
                                resource: this.getResourceName(),
                                piggyResource: this.getPiggyResourceName(),
                                errorMessage: true, successMessage: this.props.dialogTitle + " deleted."
                            }));
                            this.handleToggleConfirmModal()
                        }}
                    />

                    <DocumentPreviewModal
                        show={this.state.previewDocumentDialog}
                        translate={translate}
                        item={data[this.state.documentIndex]}

                        onButtonClick={this.handleDownloadDocument}
                        buttonLabel={translate("btn.Download")}
                        closeButtonLabel={translate("btn.close")}
                        onClose={this.handleToggleViewDocument}
                        isLoading={this.props.download.isLoading}

                        showPreviousButton={this.state.documentIndex > 0}
                        showNextButton={this.state.documentIndex < (data.length - 1)}
                        onNextDocumentPreviewClick={this.handleOnNextDocumentPreviewClick}
                        onPreviousDocumentPreviewClick={this.handleOnPreviousDocumentPreviewClick}
                        onEditButtonClick={this.props.documentUpdateFields ? this.handleToggleUpdateModal : null}
                        hasEditPerm={this.props.hasEditPerm ?? !this.props.readOnly}
                        hasEditButton={this.props.hasEditButton}
                        dispatch={this.props.dispatch}
                        onUploadVersion={this.onUploadVersion}

                        primaryKey={this.getPrimaryKey()}
                        id={this.getId()}
                        resourceName={this.getResourceName()}
                        onReturnExpiryDate={this.handleReturnExpiryDate}
                        query={this.getQuery()}
                    />

                    <ModalDefault
                        show={this.state.showPreviewModal}
                        widthClass={'max-w-7xl'}
                        title={translate("modal_heading.Preview")}
                        limitHeight={true}

                        close={() => this.setState({showPreviewModal: false, previewFile: null})}
                        closeButtonLabel={translate('btn.close')}
                        onClose={() => this.setState({showPreviewModal: false, previewFile: null})}
                        buttonLabel={translate('Download')}
                        onButtonClick={() => {
                            this.downloadPreview(URL.createObjectURL(this.state.previewFile), this.state.previewFile.name)
                        }}
                    >
                        {!!this.state.previewFile && (
                            <div className="flex justify-center">
                                <FileViewer
                                    filePath={URL.createObjectURL(this.state.previewFile)}
                                    fileType={this.state.previewFile.name.split('.').pop()}
                                    onError={(e) => {
                                        console.log(e)
                                    }}
                                />
                            </div>
                        )}
                    </ModalDefault>

                    <ModalDefault
                        show={this.state.versionsModalOpen}
                        widthClass={'max-w-5xl'}
                        title={translate("text.version_manager")}

                        close={this.handleToggleVersionsModal}
                        closeButtonLabel={translate('btn.close')}
                        onClose={this.handleToggleVersionsModal}
                    >
                        <DocumentVersionsModal
                            translate={translate}
                            isLoading={isLoading}
                            dispatch={this.props.dispatch}
                            selectedItem={this.state.selectedItem}
                            onUploadVersion={this.onUploadVersion}
                            createOnly={createOnly}
                            id={this.getId()}
                            documentTypes={this.props.documentTypes}
                            resourceName={this.getResourceName()}
                            handleDownloadDocument={this.downloadDocument}
                            onReturnExpiryDate={this.handleReturnExpiryDate}
                            onEditDocument={(params) => {
                                this.props.dispatch(updateResource({
                                    user: LocalStorage.get('user'),
                                    params: params,
                                    query: this.getQuery(),
                                    resource: this.getResourceName(),
                                    piggyResource: this.getPiggyResourceName(),
                                    errorMessage: true,
                                    successMessage: `Document has been updated`,
                                }))
                            }}
                            onDocumentDelete={(document) => {
                                let id = document[this.getPrimaryKey()]
                                this.props.dispatch(deleteResource({
                                    user: LocalStorage.get("user"),
                                    query: {
                                        [this.getPrimaryKey()]: id
                                    },
                                    piggyQuery: this.getQuery(),
                                    resource: this.getResourceName(),
                                    piggyResource: this.getPiggyResourceName(),
                                    errorMessage: true, successMessage: this.props.dialogTitle + " deleted."
                                }));
                            }}
                            query={this.getQuery()}
                        />
                    </ModalDefault>

                    <ModalDefault
                        show={this.state.uploadFilesModalOpen}
                        widthClass={'max-w-5xl'}
                        title={translate("modal_heading.upload_confirm")}
                        limitHeight={true}

                        close={this.handleCancelUpload}
                        closeButtonLabel={translate('btn.cancel')}
                        onClose={this.handleCancelUpload}

                        buttonDisabled={!this.state.canSubmit}
                        buttonLabel={translate('Upload')}
                        onButtonClick={this.handleUploadDocument}
                    >
                        <div className="px-5 pt-5 pb-40">
                            {this.state.files.map((it, i) => {
                                const label = this.docsTypes[it.fields?.DocumentTypeID?.value ?? undefined] || '';

                                if (this.documentLabelTest(label) && !!it.fields?.IsSendWithInvoice && !!it.fields?.IsVisibleForCustomer && CompanyExceptions('AutoCheckPODDocumentCheckboxes', true)) {
                                    it.fields.IsSendWithInvoice.value = 1;
                                    it.fields.IsVisibleForCustomer.value = 1;
                                }

                                const itemToHtml = fieldsToHtml(Object.values(Object.assign({}, it.fields)), translate, (name, value) => this.handleInputChange(name, value, i), {
                                    DocumentTypeID:
                                        this.props.documentTypes ? this.props.documentTypes :
                                            getLookup('DocumentType')
                                })

                                return (
                                    <div key={i}>
                                        {!!i && (
                                            <div className={'border-b border-tm-gray-300 mb-4 p-4 -ml-4 -mr-4'}/>
                                        )}

                                        <div className="flex items-center mb-4 justify-between">
                                            <div
                                                className="flex items-center text-sm font-semibold text-tm-gray-900 break-all"
                                            >
                                                {this.state.files.length > 1 && (
                                                    <div
                                                        className='w-10 h-10 mr-2 rounded-full flex items-center justify-center bg-tm-gray-50'>
                                                        <CardSubTitle
                                                            text={i + 1}
                                                        />
                                                    </div>
                                                )}

                                                <label>{translate("text.desc_for_file")}: {this.state.files[i].name}</label>
                                            </div>
                                            <div className="text-right">
                                                <button
                                                    className="btn btn-icon"
                                                    title={translate('text.preview')}
                                                    onClick={() => this.showPreviewModal(it)}
                                                >
                                                    <EyeIcon className="h-4 w-4"/>
                                                </button>

                                                <button
                                                    className="btn btn-icon"
                                                    title={translate('text.delete')}
                                                    onClick={() => this.handleRemoveDocumentFromUpload(i)}
                                                >
                                                    <TrashIcon className="h-4 w-4"/>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="grid gap-4">
                                            {this.state.files.length > 1 && !i && (
                                                <label
                                                    className="h-9 flex items-center justify-start px-2 -ml-2 w-full cursor-pointer hover:bg-tm-gray-50"
                                                >
                                                    <FieldCheckbox
                                                        className={
                                                            classNames(
                                                                "checkbox",
                                                                this.state.willCopyValues
                                                                    ? "border-primary"
                                                                    : "border-tm-gray-400"
                                                            )
                                                        }
                                                        onChange={() => this.setState(
                                                            {willCopyValues: !this.state.willCopyValues}
                                                        )}
                                                        value={this.state.willCopyValues}
                                                    />

                                                    <div
                                                        className="ml-2 flex flex-col text-sm font-semibold select-none text-tm-gray-900"
                                                    >
                                                        {translate("text.copy_to_other_fields")}
                                                    </div>
                                                </label>
                                            )}

                                            {itemToHtml}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </ModalDefault>

                    <ModalSaveResource
                        title={"Edit document"}
                        gridColsClass={"grid-cols-12"}
                        show={this.state.isUpdateModalOpen}
                        keyid={this.props.primaryKey}
                        value={this.state.selectedItem}
                        translate={translate}
                        fields={this.getUpdateFields(this.state.selectedItem)}
                        onClose={this.handleToggleUpdateModal}
                        onSubmit={(params) => {
                            if (params) {
                                params.id = this.state.selectedItem.DocumentID ?? this.state.selectedItem[this.props.primaryKey]
                                this.props.dispatch(updateResource({
                                    user: LocalStorage.get('user'),
                                    params: params,
                                    query: this.getQuery(),
                                    resource: this.getResourceName(),
                                    piggyResource: this.getPiggyResourceName(),
                                    errorMessage: true,
                                    successMessage: `Document has been updated`,
                                }))
                                this.handleToggleUpdateModal()
                            }
                        }}
                        resourceName={this.getResourceName()}
                        metadata={{}}
                        {...this.props}
                    />

                    {!disableSendViaEmail && (
                        <EmailDocumentDialog
                            show={this.state.emailModalOpen}
                            title={translate("modal_heading.send_document_via_email")}
                            widthClass="max-w-5xl"
                            onClose={this.toggleSendEmailDialog}
                            fields={this.getEmailFields()}
                            metadata={{
                                AddContactID: {
                                    api: "api/" + Resources.ContactsQuick,
                                    query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
                                    searchMap: (item) => ({
                                        value: item.Email,
                                        label: item.FirstName + " " + item.LastName
                                    })
                                },
                                EmailTemplateID: {
                                    api: 'api/' + Resources.EmailTemplates,
                                    query: {offset: 0, sort: "ASC", limit: 10},
                                    searchMap: (item) => ({
                                        value: item.EmailTemplateID,
                                        label: item.EmailTemplateName
                                    })
                                }
                            }}
                            onSubmit={(params) => {
                                if (params) {
                                    let emails = params.emails.filter(it => !it.invalid).reduce((memo, it) => {
                                        memo += it.value + ",";
                                        return memo
                                    }, "");

                                    this.props.dispatch(createResource({
                                        user: LocalStorage.get("user"),
                                        query: this.getQuery(),
                                        params: Object.assign({}, params, {
                                            PhysicalLocation: this.state.selectedItem?.PhysicalLocation,
                                            emails: emails.substring(0, emails.length - 1)
                                        }),
                                        resource: Resources.DocumentsSend,
                                        errorMessage: true, successMessage: "Emails sent."
                                    }));

                                    this.toggleSendEmailDialog()
                                }
                            }}
                            document={this.state.selectedItem}
                            onDownload={() => {
                                this.downloadDocument(this.state.selectedItem)
                            }}
                            fileType={this.state.selectedItem?.OriginalFilename?.split('.')?.pop()}
                            filePath={Env.getApiUrl("api/" + this.getResourceName(), Object.assign({}, {
                                [this.getPrimaryKey()]: this.state?.selectedItem && this.state.selectedItem[this.getPrimaryKey()],
                                token: getJWT().access_token,
                                id: this.getId()
                            }))}
                            fetchEmailTemplateQuery={this.props.fetchEmailTemplateQuery}
                            {...this.props}
                        />
                    )}
                </Card>
            </div>

            {this.props.htmlAfter && this.props.htmlAfter(this.getQuery())}
        </>
    }
}